
import React, { useState } from 'react';
import { useTesseract } from 'react-tesseract';

const Ocr = () => {
    const [imageUrl, setImageUrl] = useState('');
    const { recognize, result, isRecognizing, error } = useTesseract();

    const handleRecognize = async () => {
        if (imageUrl) {
            await recognize(imageUrl, { language: 'eng' });
        }
    };

    return (
        <div>
            <input type="file" onChange={(e) => setImageUrl(URL.createObjectURL(e.target.files[0]))} />
            <button onClick={handleRecognize} disabled={!imageUrl || isRecognizing}>Scan MyKad</button>
            {error && <p>Error: {error}</p>}
            {result && <pre>{result}</pre>}
        </div>
    );
}

export default Ocr;